/** @jsxImportSource @emotion/react */
import React from "react";
import { jsx, css } from "@emotion/react";
import { useEffect, useState, forwardRef } from "react";
import ClearIcon from "@mui/icons-material/Clear";
import Swal from "sweetalert2";
import axios from "axios";
import { useHistory } from "react-router-dom";
import Loading from "./Loading";
import Layout from "./Layout";
import { DataGrid } from "@mui/x-data-grid";
import AddIcon from "@mui/icons-material/Add";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import Slide from "@mui/material/Slide";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import InputLabel from "@mui/material/InputLabel";
import FormControl from "@mui/material/FormControl";
import { loginState, configState } from "../lib/State";
import log from "../lib/log";
import pr from "../lib/pr";
import CenterSelect from "./CenterSelect";
import MemberSearch from "./MemberSearch";
import {
  Select,
  MenuItem,
  AppBar,
  Toolbar,
  Typography,
  RadioGroup,
  Radio,
  FormControlLabel,
  FormLabel,
} from "@mui/material";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import { ko } from "date-fns/locale";
import moment from "moment";
import ProductSearch from "./ProductSearch";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers";
import styled from "@emotion/styled";
import add_comma from "../lib/add_comma";

const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

// 등록하기 팝업
function OrderEdit(props) {
  const { login, onClosePop, seq } = props;
  const token = localStorage.getItem("token");
  const [centers, setCenters] = useState([]);
  const [tcid, setTcid] = useState("");
  const [showMemberSearch, setShowMemberSearch] = useState(false);
  const [showProductSearch, setShowProductSearch] = useState(false);
  const [amount, setAmount] = useState(0);
  const [salePrice, setSalePrice] = useState(0);
  const [pid, setPid] = useState("");
  const [tmcd, setTmcd] = useState("");

  const [mname, setMname] = useState("");
  const [sdate, setSdate] = useState(null);
  const [edate, setEdate] = useState(null);
  const [order_date, setOrderDate] = useState(null);
  const [refund_edate, setRefundEdate] = useState(null);  
  const [pname, setPname] = useState("");  
  const [total_amount, setTotalAmount] = useState(0);
  const [total_count, setTotalCount] = useState(0);
  const [use_count, setUseCount] = useState(0);
  const [remain_count, setRemainCount] = useState(0);
  const [remain_day, setRemainDay] = useState(0);
  const [final_amount, setFinalAmount] = useState(0);
  const [minus_coupon_amount, setMinusCouponAmount] = useState(0);
  const [minus_day_amount, setMinusDayAmount] = useState(0);
  const [state, setState] = useState('');
  const [manager, setManager] = useState('');
  const [enable_count, setEnableCount] = useState(0); // 환불가능 쿠폰
  const [fee, setFee] = useState(0); // 환불 수수료
  const [expect_amount, setExpectAmount] = useState(0); // 환불 예상금액
  const [updated, setUpdated] = useState('');
  const [reason, setReason] = useState('');
  const [cname, setCname] = useState('');

  const onSubmit = async () => {
    let result = await axios.post(
      configState.api + "/gympass_admin/refund_edit",
      {
        token: token,
        cid: login.cid,
        level: login.level,
        mcd: login.mcd,
        seq: seq,
        sdate:sdate,
        edate: edate,
        refund_edate: refund_edate,
        total_amount: total_amount,
        final_amount: final_amount,
        total_count: total_count,
        use_count: use_count,
        remain_count: remain_count,
        remain_day: remain_day,
        minus_coupon_amount: minus_coupon_amount,
        minus_day_amount: minus_day_amount,
        state: state,
        manager: manager,
        reason: reason,
      }
    );
    if (result.data.success !== 1) {
      Swal.fire(result.data.msg);
      return;
    } else {
      Swal.fire({ title: "수정되었습니다.", showCloseButton: true }).then(
        (result) => {
          onClosePop();
        }
      );
    }
  };

  const load_data = async () => {
    let result = await axios.post(
      configState.api + "/gympass_admin/refund_one",
      {
        token: token,
        cid: login.cid,
        level: login.level,
        mcd: login.mcd,
        seq: seq,
      }
    );
    if (result.data.success === 1) {
      setMname(result.data.row.mname);
      setPname(result.data.row.pname);
      setOrderDate(result.data.row.order_date);
      setSdate(result.data.row.sdate);
      setEdate(result.data.row.edate);
      setRefundEdate(result.data.row.refund_edate);
      setTotalAmount(result.data.row.total_amount);
      setTotalCount(result.data.row.total_count);
      setUseCount(result.data.row.use_count);
      setRemainCount(result.data.row.remain_count);
      setRemainDay(result.data.row.remain_day);
      setFinalAmount(result.data.row.final_amount);
      setMinusCouponAmount(result.data.row.minus_coupon_amount);
      setMinusDayAmount(result.data.row.minus_day_amount);
      setState(result.data.row.state);
      setManager(result.data.row.manager);
      setUpdated(result.data.row.updated);
      setReason(result.data.row.reason);
      setCname(result.data.row.cname);
    } else {
      Swal.fire(result.data.msg);
      return;
    }
  };

  const onDeleteClick = () => {
    Swal.fire({
      title: "삭제하시겠습니까?",
      showConfirmButton: true,
      showCancelButton: true,
    })
      .then(async (result) => {
        if (result.isConfirmed) {
          let result = await axios.post(
            configState.api + "/gympass_admin/refund_del",
            {
              token: token,
              cid: login.cid,
              level: login.level,
              mcd: login.mcd,
              seq: seq,
            }
          );
          if (result.data.success === 1) {
            onClosePop();
          } else {
            Swal.fire(result.data.msg);
          }
        }
      })
      .catch((e) => alert(e));
  };

  useEffect(() => {
    load_data();
  }, []);

  const onChangeMethod = (e) => {
    // const onChangeMethod = (e) => {
    //   setMethod(e.target.value);
    // }
  }

  // 남은 1일당 쿠폰 하나 인정
  useEffect(() => {
    let count = remain_count;
    let left_price = 0;
    if(parseInt(remain_count) > parseInt(remain_day)) {
      count = parseInt(remain_day);
      left_price = (remain_count - remain_day) * 30000
    }    
    let tmp_expect_amount=0;
    if(total_count>0) {
      tmp_expect_amount = total_amount - fee - use_count * 30000 - left_price
    }
    if(tmp_expect_amount<0) tmp_expect_amount=0;
    
    setEnableCount(count); // 환불가능 쿠폰
    setExpectAmount(tmp_expect_amount); // 환불 예상금액
    setFee(total_amount*0.1); // 환불 수수료
  },[total_amount, remain_count, remain_day]);

  // 사용쿠폰 수정시
  useEffect(()=>{
    setRemainCount(total_count - use_count);
  }, [use_count])

  return (
    <Box>

      <Box
        css={css`
          padding: 50px 60px;
        `}
      >

        {/* 고객명 */}
        <Box
          css={css`
            margin-top: 10px;
          `}
        >
          센터명 : {cname}
        </Box>

        {/* 고객명 */}
        <Box marginTop={1}>
          고객명 : {mname}
        </Box>

        {/* 상품명 */}
        <Box marginTop={1}>
          상품명 : {pname}
        </Box>        
        {/* 상품명 */}
        <Box marginTop={1}>
          결제일 : {order_date} / 수정일 : {updated}
        </Box>        

        {/* 시작일 */}
        <Box sx={{ mt: 2, display: "flex" }}>
          <Box>
            <LocalizationProvider dateAdapter={AdapterDateFns} locale={ko}>
              <DatePicker
                allowSameDateSelection={true}
                label="시작일"
                value={sdate}
                onChange={(newValue) => {
                  setSdate(moment(newValue).format("YYYY-MM-DD"));
                }}
                renderInput={(params) => <TextField size="small" {...params} />}
                inputFormat={"yyyy.MM.dd"}
                autoComplete="off"
              />
            </LocalizationProvider>
          </Box>

          <Box sx={{ ml: 1 }}>
            <LocalizationProvider dateAdapter={AdapterDateFns} locale={ko}>
              <DatePicker
                allowSameDateSelection={true}
                label="종료일"
                value={edate}
                onChange={(newValue) => {
                  setEdate(moment(newValue).format("YYYY-MM-DD"));
                }}
                renderInput={(params) => <TextField size="small" {...params} />}
                inputFormat={"yyyy.MM.dd"}
                autoComplete="off"
              />
            </LocalizationProvider>
          </Box>
          <Box sx={{ ml: 1 }}>
            <LocalizationProvider dateAdapter={AdapterDateFns} locale={ko}>
              <DatePicker
                allowSameDateSelection={true}
                label="서버스 종료일"
                value={refund_edate}
                onChange={(newValue) => {
                  setRefundEdate(moment(newValue).format("YYYY-MM-DD"));
                }}
                renderInput={(params) => <TextField size="small" {...params} />}
                inputFormat={"yyyy.MM.dd"}
                autoComplete="off"
              />
            </LocalizationProvider>
          </Box>
        </Box>

        <Box sx={{ display: "flex", mt: 2 }}>
          {/* 판매가 */}
          <Box>
            <FormControl sx={{ width: 150 }}>
              <TextField
                name="total_amount"
                label="구매가"
                size="small"
                autoComplete="off"
                value={total_amount}
                onChange={(e)=>setTotalAmount(e.target.value)}
              ></TextField>
            </FormControl>
          </Box>
          <Box sx={{ ml: 1 }}>
            <FormControl sx={{ width: 150 }}>
              <TextField
                name="minus_coupon_amount"
                label="쿠폰차감금액"
                size="small"
                autoComplete="off"
                value={minus_coupon_amount}
                onChange={(e)=>setMinusCouponAmount(e.target.value)}
              ></TextField>
            </FormControl>
          </Box>
          <Box sx={{ ml: 1 }}>
            <FormControl sx={{ width: 150 }}>
              <TextField
                name="minus_day_amount"
                label="잔여일차감금액"
                size="small"
                autoComplete="off"
                value={minus_day_amount}
                onChange={(e)=>setMinusDayAmount(e.target.value)}
              ></TextField>
            </FormControl>
          </Box>
          <Box sx={{ ml: 1 }}>
            <FormControl sx={{ width: 150 }}>
              <TextField
                name="final_amount"
                label="환불금액"
                size="small"
                autoComplete="off"
                value={final_amount}
                onChange={(e)=>setFinalAmount(e.target.value)}
              ></TextField>
            </FormControl>
          </Box>
        </Box>

        <Box sx={{ display: "flex", mt: 2 }}>
          <Box>
            <FormControl sx={{ width: 150 }}>
              <TextField
                name="name"
                label="구매쿠폰"
                size="small"
                autoComplete="off"
                value={total_count}
                onChange={(e)=>setTotalCount(e.target.value)}
              ></TextField>
            </FormControl>
          </Box>            
          <Box sx={{ ml: 1 }}>
            <FormControl sx={{ width: 150 }}>
              <TextField
                name="use_count"
                label="사용쿠폰/사용일"
                size="small"
                autoComplete="off"
                value={use_count}
                onChange={(e)=>setUseCount(e.target.value)}
              ></TextField>
            </FormControl>
          </Box>
          <Box sx={{ ml: 1 }}>
            <FormControl sx={{ width: 150 }}>
              <TextField
                name="remain_count"
                label="잔여쿠폰/잔여일"
                size="small"
                autoComplete="off"
                value={remain_count}
                onChange={(e)=>setRemainCount(e.target.value)}
              ></TextField>
            </FormControl>
          </Box>
          <Box sx={{ ml: 1 }}>
            <FormControl sx={{ width: 150 }}>
              <TextField
                name="remain_day"
                label="잔여일"
                size="small"
                autoComplete="off"
                value={remain_day}
                onChange={(e)=>setRemainDay(e.target.value)}
              ></TextField>
            </FormControl>
          </Box>
        </Box>
        <Box>
            <FormControl sx={{ width: 250, mt: 2 }}>
              <TextField
                name="name"
                label="사유"
                size="small"
                autoComplete="off"
                multiline
                maxRows={4}
                value={reason}
                onChange={(e)=>setReason(e.target.value)}
              ></TextField>
            </FormControl>
          </Box>

        <Box sx={{ display: "flex", mt: 2 }}>
          
        </Box>     

        {/* 상태 */}
        <FormControl
          fullWidth
          css={css`
            margin-top: 10px;
          `}
        >
          <FormLabel>상태</FormLabel>
          <RadioGroup
            row
            aria-labelledby="demo-radio-buttons-group-label"
            defaultValue="female"
            name="state"
            onChange={(e)=>setState(e.target.value)}
            value={state}
          >
            <FormControlLabel value="회원신청" control={<Radio />} label="회원신청" />
            <FormControlLabel value="지점승인" control={<Radio />} label="지점승인" />
            <FormControlLabel value="본사처리" control={<Radio />} label="본사처리" />
            <TextField
            name="manager"
            label="담당자"
            size="small"
            sx={{
              width: "150px",
            }}
            autoComplete="off"
            value={manager}
            onChange={(e)=>setManager(e.target.value)}
          ></TextField>
          </RadioGroup>
        </FormControl>

        <Box
          css={css`
            text-align: center;
            margin-top: 30px;
          `}
        >

          
          { 
          // 지점은 본사 처리 전까지 수정가능
          login.level==='100' && state !== '본사처리' && 
          <Button variant="contained" onClick={onSubmit}>
            수정완료
          </Button> }


          { login.level==='500' &&
          <Button variant="contained" onClick={onSubmit}>
            수정완료
          </Button> }

          <Button
            variant="contained"
            css={css`
              margin-left: 10px;
            `}
            onClick={onClosePop}
          >
            닫기
          </Button>

          { login.level === '500' &&
          <Button
            variant="contained"
            color="warning"
            css={css`
              margin-left: 10px;
            `}
            onClick={onDeleteClick}
          >
            삭제
          </Button> }

        </Box>
      </Box>
    </Box>
  );
}

export default OrderEdit;
